import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FadeIn } from "@/components/common";

const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_goose-platform/artifacts/eydl4x1d_Goose%20Logo2.png";

export default function Signup() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6 font-[Satoshi,sans-serif] antialiased">
      <FadeIn>
        <div className="flex w-full max-w-[460px] flex-col items-center text-center" data-testid="signup-placeholder">
          <img src={LOGO} alt="Goose — powered by HAEVN" className="w-[220px]" />

          <h1 className="mt-10 font-display text-3xl font-extrabold tracking-tight text-[#0B1221]">
            Become a Goose partner
          </h1>
          <p className="mt-4 text-lg leading-relaxed text-[#5A6B7B]">
            Our new-partner application is coming next. Soon you’ll be able to apply here to
            bring Goose to the singles events you produce.
          </p>

          <button
            data-testid="signup-back-link"
            onClick={() => navigate("/")}
            className="group mt-10 inline-flex items-center gap-1.5 text-base font-semibold text-[#5A6B7B] transition-colors duration-200 hover:text-[#FF2A5F]"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" />
            Back to Goose
          </button>
        </div>
      </FadeIn>
    </div>
  );
}
